<section class="super-ejecutivo-panel" role="dialog" [attr.aria-label]="'Conversación con ' + nombre"
  [class.super-ejecutivo-panel--moderado]="tamano() === 'moderado'"
  [class.super-ejecutivo-panel--agrandado]="tamano() === 'agrandado'"
  [class.super-ejecutivo-panel--completo]="tamano() === 'completo'"
  [style]="estiloArea()">
  <header class="super-ejecutivo-encabezado">
    <div class="super-ejecutivo-titulo">
      <mat-icon>smart_toy</mat-icon>
      <div>
        <strong>{{ nombre }}</strong>
        <span>Analista de operación</span>
      </div>
    </div>
    <div class="super-ejecutivo-acciones">
      <button mat-icon-button matTooltip="Nueva conversación" aria-label="Nueva conversación"
        [disabled]="superEjecutivo.procesando()" (click)="superEjecutivo.nuevaConversacion()">
        <mat-icon>add_comment</mat-icon>
      </button>
      @if (tamano() !== 'completo') {
        <button mat-icon-button (click)="superEjecutivo.alternarTamano()"
          [matTooltip]="tamano() === 'moderado' ? 'Agrandar' : 'Regresar al tamaño normal'"
          [attr.aria-label]="tamano() === 'moderado' ? 'Agrandar' : 'Regresar al tamaño normal'">
          <mat-icon>{{ tamano() === 'moderado' ? 'open_in_full' : 'close_fullscreen' }}</mat-icon>
        </button>
      }
      <button mat-icon-button matTooltip="Cerrar" aria-label="Cerrar" (click)="superEjecutivo.cerrar()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="super-ejecutivo-mensajes" #listaMensajes>
    @if (conversacionVacia()) {
      <div class="super-ejecutivo-bienvenida">
        <p>{{ bienvenida }}</p>
        <div class="super-ejecutivo-ejemplos">
          @for (pregunta of preguntasEjemplo; track pregunta) {
            <button mat-stroked-button class="super-ejecutivo-ejemplo" (click)="preguntar(pregunta)">{{ pregunta }}</button>
          }
        </div>
      </div>
    }

    @for (mensaje of superEjecutivo.mensajes(); track mensaje.id; let ultimo = $last) {
      @switch (mensaje.rol) {
        @case ('usuario') {
          <div class="super-ejecutivo-mensaje super-ejecutivo-mensaje--usuario">{{ mensaje.texto }}</div>
        }
        @case ('superEjecutivo') {
          <div class="super-ejecutivo-mensaje super-ejecutivo-mensaje--super-ejecutivo">
            @if (mensaje.texto) {
              <app-super-ejecutivo-markdown [texto]="mensaje.texto" [enCurso]="ultimo && superEjecutivo.procesando()"></app-super-ejecutivo-markdown>
            }
            @for (propuesta of mensaje.propuestas; track propuesta.approvalId) {
              <app-super-ejecutivo-propuesta [propuesta]="propuesta" [deshabilitada]="superEjecutivo.procesando()"
                (decidir)="decidir(propuesta.approvalId, $event)"></app-super-ejecutivo-propuesta>
            }
          </div>
        }
        @case ('aviso') {
          <div class="super-ejecutivo-aviso">
            <mat-icon>info</mat-icon>{{ mensaje.texto }}
          </div>
        }
      }
    }

    @if (superEjecutivo.procesando() && superEjecutivo.avance()) {
      <div class="super-ejecutivo-avance">
        <mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner>
        <span>{{ superEjecutivo.avance() }}</span>
      </div>
    }

    @if (superEjecutivo.error()) {
      <div class="super-ejecutivo-error">
        <span>{{ superEjecutivo.error() }}</span>
        @if (superEjecutivo.puedeReintentar()) {
          <button mat-stroked-button class="boton-guardar" [disabled]="superEjecutivo.procesando()" (click)="superEjecutivo.reintentar()">
            <mat-icon>refresh</mat-icon>Reintentar
          </button>
        }
      </div>
    }
  </div>

  <footer class="super-ejecutivo-pie">
    <mat-form-field class="super-ejecutivo-campo" subscriptSizing="dynamic">
      <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="6"
        [attr.aria-label]="'Mensaje para ' + nombre" placeholder="Escribe tu pregunta"
        [value]="superEjecutivo.borrador()" (input)="alEscribir($event)"
        (keydown.enter)="alPresionarEnter($event)"></textarea>
      @if (largo() >= cercaDelLimite) {
        <mat-hint align="end" class="contador-caracteres"
          [class.contador-cercano]="!muyLargo()" [class.contador-limite]="muyLargo()">
          {{ muyLargo() ? mensajeMuyLargo : largo() + ' / ' + maximoCaracteres }}
        </mat-hint>
      }
    </mat-form-field>
    <button mat-icon-button class="super-ejecutivo-enviar" aria-label="Enviar" matTooltip="Enviar"
      [disabled]="!puedeEnviar()" (click)="enviar()">
      <mat-icon>send</mat-icon>
    </button>
  </footer>
</section>
